import { gql } from '@apollo/client';
import { useApolloClient, useMutation } from '@apollo/client/react';
import Button from '@mui/material/Button';
import { homeQuery } from '../../main/queries';

const MarkAsCompleteButton = ({ booking }: { booking: { id: number } }) => {
    const client = useApolloClient();

    const [updateBookingStatus] = useMutation(
        gql`
            mutation updateBookingStatus($bookingId: Int!, $status: String!) {
                updateBookingStatus(bookingId: $bookingId, status: $status)
            }
        `,
        {
            variables: {
                bookingId: booking.id,
                status: 'complete',
            },
            refetchQueries: [
                {
                    query: homeQuery,
                },
            ],
        }
    );

    return (
        <Button
            variant="contained"
            onClick={() => {
                updateBookingStatus()
                    .then(async () => {
                        await client.clearStore();
                        await client.refetchObservableQueries();
                    })
                    .catch(error => {
                        throw error;
                    });
            }}
        >
            Mark as complete
        </Button>
    );
};

export default MarkAsCompleteButton;
